import gql from 'graphql-tag'

export const GET_MARKETPLACE_ORDERS = gql`
    query getMarketplaceOrdersQuery($page: Int, $count: Int! = 10) {
        viewer {
            account {
                indexedOrders(
                    sources: [MARKETPLACE]
                    first: $count
                    page: $page
                ) {
                    paginator {
                        totalCount
                    }
                    results {
                        link
                        orderable {
                            id
                            number
                            originalTotalPrice
                            totalPrice
                            convertedAt
                            paymentUrl
                            paymentStatus
                            status
                            storefrontNames
                            location
                            paymentMethod {
                                id
                                name
                            }
                            isPaid
                            isAuthorized
                            payments {
                                externalStatus
                                externalDueAt
                            }
                            isSepaPayment
                            isPaaPayment
                            isPaid
                            isCancelled
                            hasPendingAuthorization
                            id
                            number
                            totalPrice
                            convertedAt
                            paymentUrl
                            paymentStatus
                            status
                            paymentMethod {
                                id
                                name
                            }
                            isSepaPayment
                            isPaaPayment
                            isPaid
                            isAuthorized
                            storefrontNames
                        }
                    }
                }
            }
        }
    }
`

export const GET_REVIEW_ORDER_BY_ID_QUERY = gql`
    query getReviewOrderByIdQuery($id: ID!) {
        order: retailerOrder(id: $id) {
            id
            number
            supplierOrders(first: 30) {
                edges {
                    node {
                        id
                        storefronts(first: 10) {
                            edges {
                                node {
                                    id
                                    slug
                                    name
                                    avatar: storyImage {
                                        transformedUrl(
                                            width: 100
                                            height: 100
                                            method: CROP
                                        )
                                    }
                                    reviews(retailerOrder: $id, first: 1) {
                                        edges {
                                            node {
                                                id
                                                score
                                                content
                                                isUpdatable
                                            }
                                        }
                                    }
                                    isReviewable(retailerOrder: $id)
                                }
                            }
                        }
                        products(first: 10) {
                            edges {
                                node {
                                    id
                                    quantity
                                    title
                                    variantTitle
                                    unitPrice
                                    subtotalPrice
                                    listing {
                                        title
                                        id
                                        databaseId
                                        isPublished
                                        storefront {
                                            id
                                            slug
                                            name
                                        }
                                        image {
                                            transformedUrl(
                                                width: 100
                                                height: 100
                                                method: FILL
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`

export const GET_RETAILER_ORDER_FEEDBACK_QUERY = gql`
    query getOrderFeedbackByRetailerQuery(
        $isVisibleOnDashboard: Boolean = true
        $first: Int = 3
        $page: Int = 0
        $sort: OrderFeedbackSort = STATUS_UPDATED_AT_DESC
    ) {
        viewer {
            account {
                orderFeedback(
                    isVisibleOnDashboard: $isVisibleOnDashboard
                    first: $first
                    page: $page
                    sort: $sort
                ) {
                    data {
                        id
                        status
                        reason
                        isResolved
                        createdAt
                        retailerOrder {
                            id
                            number
                        }
                        brand {
                            name
                        }
                    }
                    paginatorInfo {
                        total
                    }
                }
            }
        }
    }
`

export const ORDER_FEEDBACK_RESOLVE_MUTATION = gql`
    mutation orderFeedbackResolveMutation($id: ID!) {
        orderFeedbackResolve(id: $id) {
            id
            status
        }
    }
`
export const GET_TICA_ORDER_DETAILS_BY_ID_QUERY = gql`
    query getTicaOrderDetailsByIdQuery($id: ID!) {
        order: ticaOrder(id: $id) {
            createdAt
            id
            number
            totalPrice
            subtotalPrice
            taxPrice
            location
            products {
                ticaArticleNumber
                ticaSupplierNumber
                ticaArticleTitle
                ticaSupplierName
                quantity
                taxFactor
                taxPrice
                unitPrice
                oldUnitPrice
                discountPrice
                subtotalPrice
                totalPrice
                listing {
                    id
                    databaseId
                    title
                    isPublished
                    isReorderOnly
                    isOrderWriterOnly
                    images(first: 1) {
                        edges {
                            node {
                                id
                                transformedUrl(
                                    width: 100
                                    height: 100
                                    method: FILL
                                )
                            }
                        }
                    }
                }
                listingVariant {
                    id
                    options {
                        name
                        value
                    }
                }
                # TODO: Can be deleted?
                storefront {
                    id
                    name
                    slug
                    status
                    avatar: storyImage {
                        transformedUrl(width: 128, height: 128, method: CROP)
                    }
                }
                # TODO: This breaks sometimes when there are no connected products
                storefronts {
                    id
                    name
                    slug
                    avatar: storyImage {
                        transformedUrl(width: 128, height: 128, method: CROP)
                        __typename
                    }
                }
            }
        }
    }
`

export const MARK_SHIPMENT_AS_DELIVERED = gql`
    mutation markShipmentAsDelivered($input: MarkShipmentAsDeliveredInput!) {
        markShipmentAsDelivered(input: $input) {
            success
        }
    }
`

export const GET_ORDER_DETAILS_BY_ID_QUERY = gql`
    query getOrderDetailsByIdQuery(
        $id: ID!
        $after: String
        $shipmentAfter: String
    ) {
        order: retailerOrder(id: $id) {
            token
            canChangeAddress
            canBePublished
            amountDue
            amountPaid
            createdAt
            cancelledAt
            canReportIssue
            canBeCancelled
            isCancelled
            canReportIssue
            isCancelledBySupplier
            id
            number
            databaseId
            paymentProvider
            isPaid
            isAuthorized
            status
            productFeedbackReasons
            invoiceFeedbackReasons
            paymentMethod {
                id
                name
            }
            expectedDelivery {
                daysMin
                daysMax
                fromDate
                toDate
            }
            orderFeedback(sort: ID_DESC) {
                id
                status
                message
                reason
                resolution
                isSupplierReturnOptionEnabled
                supplierReturnInstructions
                brand {
                    name
                    storyImage {
                        originalUrl
                        transformedUrl(width: 50, height: 50, method: CROP)
                    }
                }
                isResolved
                isResolvedBySupplier
                isResolvedAutomatically
                createdAt
                statusUpdatedAt
                orderFeedbackProducts {
                    id
                    quantity
                    orderProduct(trashed: WITH) {
                        id
                        title
                        listingVariantId
                        images(first: 1) {
                            edges {
                                node {
                                    id
                                    originalUrl
                                    transformedUrl(
                                        width: 28
                                        height: 28
                                        method: CROP
                                    )
                                }
                            }
                        }
                        unitPrice
                    }
                }
                orderFeedbackFiles {
                    id
                    thumbnailUrl
                    image {
                        originalUrl
                        transformedUrl(width: 50, height: 50, method: CROP)
                    }
                }
            }
            payments {
                externalStatus
                amount
                externalDueAt
                description
                externalPaymentDetails {
                    reference
                    bankName
                    bankAccount
                    bankBic
                }
            }
            staticPayment {
                amount
                status
                externalStatus
                externalDueAt
                externalPaymentDetails {
                    reference
                    bankName
                    bankAccount
                    bankBic
                }
            }
            isSepaPayment
            isPaid
            paymentUrl
            paymentStatus
            shippingPrice
            companyName
            street
            houseNumber
            postalCode
            region
            city
            country
            isInvoiceAddressSameAsShippingAddress
            invoiceCompanyName
            invoiceStreet
            invoiceHouseNumber
            invoicePostalCode
            invoiceRegion
            invoiceCity
            invoiceCountry
            subtotalPrice
            originalTotalPrice
            originalSubtotalPrice
            taxPrice
            totalPrice
            hasFreeShipping
            discountAmount
            refundedAmount
            isRefunded
            appliedVoucher {
                id
                amount
                isPercentage
            }
            voucherPrice
            voucherTaxPrice
            invoices {
                id
                downloadPdfUrl
                number
                status
                totalPrice
                dueAt
                dueInDays
                createdAt
                paymentUrl
                amountDue
                externalAmountDue
                externalIsPaid
                externalStatus
                paymentReference
                externalAmountRefunded
                totalPrice
                isCredit
                payments {
                    status
                    externalStatus
                }
                supplierOrder {
                    storefront {
                        name
                    }
                }
                paymentMethod {
                    id
                    name
                    logos
                    description
                }
            }
            mutations {
                brand
                subtotalPrice
                productSubtotalPrice
                shippingSubtotalPrice
                discountPrice
                voucherPrice
                taxPrice
                totalPrice
                createdAt
                items {
                    orderProduct(trashed: WITH) {
                        title
                        id
                        images(first: 1) {
                            edges {
                                node {
                                    id
                                    originalUrl
                                    transformedUrl(
                                        width: 28
                                        height: 28
                                        method: CROP
                                    )
                                }
                            }
                        }
                    }
                    type
                    quantity
                    unitPrice
                    subtotalPrice
                    discountPrice
                    voucherPrice
                    taxPrice
                    totalPrice
                }
            }
            supplierOrders(first: 30) {
                totalCount
                edges {
                    node {
                        id
                        subtotalPrice
                        originalTotalPrice
                        originalSubtotalPrice
                        shippingPrice
                        feedbackReasons
                        totalPrice
                        taxPrice
                        status
                        discountName
                        discountAmount
                        discountPercentage
                        expectedDelivery {
                            daysMin
                            daysMax
                            fromDate
                            toDate
                        }
                        storefronts(first: 5) {
                            edges {
                                node {
                                    id
                                    slug
                                    name
                                    avatar: storyImage {
                                        transformedUrl(
                                            width: 100
                                            height: 100
                                            method: CROP
                                        )
                                    }
                                    reviews(retailerOrder: $id, first: 1) {
                                        edges {
                                            node {
                                                id
                                                score
                                                content
                                                isUpdatable
                                            }
                                        }
                                    }
                                    isReviewable(retailerOrder: $id)
                                    status
                                    isPublished
                                }
                            }
                        }
                        shipments(first: 6) {
                            edges {
                                node {
                                    id
                                    trackingNumber
                                    trackingUrl
                                    carrier
                                    deliveryTimeframe
                                    estimatedDeliveryAt
                                    canBeMarkedAsDeliveredByRetailer
                                    status
                                    shipmentProducts(
                                        first: 10
                                        after: $shipmentAfter
                                    ) {
                                        totalCount
                                        pageInfo {
                                            hasNextPage
                                            hasPreviousPage
                                            startCursor
                                            endCursor
                                            total
                                            count
                                            currentPage
                                            lastPage
                                        }
                                        edges {
                                            node {
                                                id
                                                title
                                                variantTitle
                                                quantity
                                                thumbnail
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        products(first: 20, after: $after) {
                            totalCount
                            pageInfo {
                                hasNextPage
                                hasPreviousPage
                                startCursor
                                endCursor
                                total
                                count
                                currentPage
                                lastPage
                            }
                            edges {
                                node {
                                    canBeReordered
                                    id
                                    brand
                                    quantity
                                    originalQuantity
                                    title
                                    variantTitle
                                    unitPrice
                                    oldUnitPrice
                                    subtotalPrice
                                    shippedCount
                                    unshippedCount
                                    shipmentStatus
                                    status
                                    estimatedShipmentDate
                                    listingVariant {
                                        image {
                                            id
                                            transformedUrl(
                                                width: 100
                                                height: 100
                                                method: FILL
                                            )
                                        }
                                    }
                                    listing {
                                        id
                                        databaseId
                                        isPublished
                                        isReorderOnly
                                        isOrderWriterOnly
                                        title
                                        storefront {
                                            id
                                            slug
                                            name
                                            isPublished
                                        }
                                    }
                                    images(first: 1) {
                                        edges {
                                            node {
                                                id
                                                transformedUrl(
                                                    width: 100
                                                    height: 100
                                                    method: FILL
                                                )
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`

export const GET_ORDER_PRODUCTS_BY_ID_QUERY = gql`
    query getOrderProductsByIdQuery($id: ID!) {
        order: retailerOrder(id: $id) {
            id
            supplierOrders(first: 20) {
                edges {
                    node {
                        id
                        products(first: 50) {
                            edges {
                                node {
                                    id
                                    brand
                                    quantity
                                    title
                                    variantTitle
                                    unitPrice
                                    canBeReordered
                                    subtotalPrice
                                    listingVariantId
                                    listing {
                                        id
                                        isPublished
                                        isReorderOnly
                                        isOrderWriterOnly
                                        storefront {
                                            id
                                            isPublished
                                        }
                                        databaseId
                                        title
                                    }
                                    images(first: 1) {
                                        edges {
                                            node {
                                                id
                                                transformedUrl(
                                                    width: 100
                                                    height: 100
                                                    method: FILL
                                                )
                                            }
                                        }
                                    }
                                    storefront {
                                        status
                                        isPublished
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`

export const PUBLISH_ECOM_MUTATION = gql`
    mutation publishEcomMutation($id: ID!) {
        retailerOrderPublish(input: { id: $id }) {
            success
            userErrors {
                field
                message
            }
        }
    }
`

export const CREATE_REVIEW_MUTATION = gql`
    mutation reviewCreateMutation(
        $storefrontId: ID!
        $orderId: ID!
        $content: String
        $score: Int!
    ) {
        reviewCreate(
            input: {
                storefrontId: $storefrontId
                orderId: $orderId
                content: $content
                score: $score
            }
        ) {
            review {
                id
            }
            userErrors {
                field
                message
            }
        }
    }
`

export const UPDATE_REVIEW_MUTATION = gql`
    mutation reviewUpdateMutation(
        $storefrontId: ID!
        $orderId: ID!
        $content: String
        $score: Int!
    ) {
        reviewUpdate(
            input: {
                storefrontId: $storefrontId
                orderId: $orderId
                content: $content
                score: $score
            }
        ) {
            review {
                id
            }
            userErrors {
                field
                message
            }
        }
    }
`

export const DOWNLOAD_IMAGES_MUTATION = gql`
    mutation productImageExport($input: ProductImageExportInput!) {
        productImageExport(input: $input) {
            products
        }
    }
`

export const CANCEL_RETAILER_ORDER_MUTATION = gql`
    mutation orderCancelMutation($retailerOrderId: ID!) {
        retailerOrderCancel(input: { retailerOrderId: $retailerOrderId }) {
            success
            message
            clientMutationId
            __typename
        }
    }
`
